import { env, version } from "@src/env";
import debounce from "debounce";

import { useMeuPlayState } from "@src/states/meuplay";
import { useOfflineModeState } from "@src/states/offline_mode";
import { usePlayerState } from "@src/states/player";

import { player } from "@src/services/player";
import { StreamProxy } from "@src/services/streamProxy";

import { isConnected } from "@src/utils/checkConnection";
import { getDeviceId } from "@src/utils/getDeviceId";
import { parseJSON } from "@src/utils/json";
import { safeFetch } from "@src/utils/safeFetch";

async function _registerRadioSession(
  method: "POST" | "DELETE",
  idRadio: string,
  cnpj?: string,
) {
  console.log("🚀 registerRadioSession");
  if (!idRadio) {
    return;
  }

  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("X-Requested-With", "XMLHttpRequest");

  const { currentTrackId, tracks } = usePlayerState.getState();
  const currentTrackObj = tracks[currentTrackId] ?? null;
  const playingOrPaused = player.getPlayingOrPaused(currentTrackId);
  const hasProxy = StreamProxy.hasProxy(currentTrackObj?.url);

  const response = await safeFetch(
    `${method} registerRadioSession`,
    `${env.api}/radio-session`,
    {
      method,
      headers,
      body: JSON.stringify({
        id_radio: idRadio,
        cnpj,
        device_id: getDeviceId(),
        player_version: version,
        url: window.location.href,
        current_track: currentTrackId,
        current_state: playingOrPaused ?? "paused",
        offline_mode: useOfflineModeState.getState().color,
        using_proxy: hasProxy ? "1" : "0",
      }),
    },
  );
  if (response.type === "error") {
    throw new Error("Failed to fetch, internet connection is down");
  }
  const data = await parseJSON("registerRadioSession", response);
  if (!response.ok || !data?.success) {
    console.error(JSON.stringify(data));
    throw new Error("Falha ao registrar sessão");
  }
  return data;
}

export const registerRadioSession = debounce(_registerRadioSession, 500, {
  immediate: true,
});

function _upsertRadioSession() {
  setTimeout(() => {
    const { radio, loginFormData } = useMeuPlayState.getState();
    const idRadio = radio?.name;
    const cnpj = loginFormData?.cnpj;
    if (idRadio) {
      registerRadioSession.clear();
      try {
        registerRadioSession("POST", idRadio, cnpj);
      } catch (error) {
        isConnected().then((isConnected) => {
          if (isConnected) {
            throw error;
          }
        });
      }
    }
  }, 0);
}

export const upsertRadioSession = debounce(_upsertRadioSession, 500, {
  immediate: true,
});
